<template>
  <div id="app">
		<component :is="'layout-'+ route.meta.layout || 'default'">
			<router-view />
		</component>
	</div>
</template>
<script lang="ts" setup>
import { useRouter, useRoute } from "vue-router";
const route = useRoute();
</script>
<style lang="scss">
.ant-form-item-control-input-content {
	align-items: center;
    display: flex;
}
.ant-input-affix-wrapper {
	line-height: 38px;
}
</style>
